export default __webpack_public_path__ + "static/media/subscribe.a4ac0c4b.png";